export const mergeCoverAndImages = (images, cover = '', coverCaption = '') => {
  if (cover.length <= 0) return images;
  // const names = images.map(i => i.image);
  // if (names.includes(cover)) return images;
  return [{ image: cover, caption: coverCaption }, ...images.filter(i => i.image !== cover)];
};

export const GalleryName = {
  DEFAULT: 'DEFAULT',
  LOCAL_TABLE: 'LOCAL_TABLE'
};

export const getGalleryProps = (trip, galleryName) => {
  if (galleryName !== null && galleryName !== undefined) {
    if (galleryName === GalleryName.DEFAULT) {
      return {
        defaultAlt: trip.name,
        images: mergeCoverAndImages(trip.images, trip.cover_image, trip.cover_image_caption),
        video: trip.video_url
      };
    }
    if (galleryName === GalleryName.LOCAL_TABLE && trip.is_localtable_trip) {
      if (trip.restaurant_ids && !!trip.restaurant_ids[0]) {
        return {
          defaultAlt: trip.restaurant_ids[0].name,
          images: mergeCoverAndImages(trip.restaurant_ids[0].images.map(data => ({ image: data })), trip.cover_image, trip.cover_image_caption),
        };
      }
      if (trip.home_cooking) {
        return {
          defaultAlt: trip.name,
          images: mergeCoverAndImages(trip.home_cooking.images, trip.cover_image, trip.cover_image_caption),
        };
      }
    }
  }
  return {};
};
